<template></template>

<script>
  import config from '../../../config';
  import CustomerHelper from '../../helpers/CustomerHelper';
  import OldErrorHandlerHelper from '../../helpers/OldErrorHandlerHelper';
  import FetchHelper from '../../helpers/OldFetchHelper';
  import LocalStorageHelper from '../../helpers/OldLocalStorageHelper';
  import CookieHelper from "../../helpers/CookieHelper";

  export default {
    data() {
      return {
        displayChat: false,
        personalInfoObj: null,
        t: window.freshchatTexts,
      };
    },
    mounted() {
      if(CookieHelper.checkIfExternalCookieIsAccepted(`freshchat`, this.setUp)) {
        this.setUp();
      }
    },
    methods: {
      getLocale() {
        // Informations about language-ids used by freshchat:
        // https://support.freshchat.com/support/solutions/articles/50000000102-localize-the-freshchat-messenger-interface
        switch(window.rinLanguage) {
          case `en`:
            return `en-gb`;
          default:
            return window.rinLanguage;
        }
      },
      initFreshChat() {
        if(!window.fcWidget) {
          OldErrorHandlerHelper.handleError(`[CHAT] no widget exists`, { logToConsole: true });
          return;
        }
        const restoreId = this.personalInfoObj.chatReference ? this.personalInfoObj.chatReference : null;
        const initialData = {
          config: {
            content: {
              headers: {
                csat_no_question: this.t.csatNoQuestion,
                csat_question: this.t.csatQuestion,
              },
            },
          },
          externalId: this.personalInfoObj.account.customerNumber.toString(),
          host: `https://wchat.eu.freshchat.com`,
          locale: this.getLocale(),
          restoreId,
          token: `35c411e6-5a21-42a3-92a4-f9fa59797e1d`,
        };
        window.fcWidget.init(initialData);

        if(restoreId === null) {
          this.setupUserdata();
        }
      },
      initialize(_i, t) {
        if(document.getElementById(t)) {
          this.initFreshChat();
          return;
        }
        const e = document.createElement(`script`);
        e.id = t;
        e.async = !0;
        e.src = `https://wchat.eu.freshchat.com/js/widget.js`;
        e.onload = this.initFreshChat;
        document.head.appendChild(e);
      },
      initiateCall() {
        this.initialize(document, `freshchat-js-sdk`);
      },
      async setUp() {
        this.personalInfoObj = LocalStorageHelper.getPersonalInfo();
        const isPersonalInfoNotComplete = !this.personalInfoObj
          || !this.personalInfoObj.account
          || !this.personalInfoObj.account.mail;

        if(isPersonalInfoNotComplete) {
          const expandedPersonalInfo = await CustomerHelper.getExpandedPersonalInfo();
          if(!expandedPersonalInfo.success) {
            OldErrorHandlerHelper.handleError(`[CHAT] expandedPersonalInfo failed`, { logToConsole: true });
          }
          this.personalInfoObj = expandedPersonalInfo.data;
        }

        const notAllowedToUse = this.personalInfoObj === null
          || !this.personalInfoObj
          || !this.personalInfoObj.isPartner
          || !this.personalInfoObj.account
          || !this.personalInfoObj.account.customerNumber
          || window.rinLanguage !== `de`;

        if(notAllowedToUse) {
          return;
        }

        this.initiateCall();
      },
      setupUserdata() {
        const userProperties = {
          email: this.personalInfoObj.account.mail ? this.personalInfoObj.account.mail : null,
          firstName: this.personalInfoObj.personalInfo.firstName ? this.personalInfoObj.personalInfo.firstName : null,
          lastName: this.personalInfoObj.personalInfo.lastName ? this.personalInfoObj.personalInfo.lastName : null,
        };
        if(window.fcWidget.user) {
          window.fcWidget.user.setProperties(userProperties);
        }
        window.fcWidget.on(`user:created`, async resp => {
          const status = resp && resp.status;
          const data = resp && resp.data;
          if(status === 200) {
            if(data.restoreId) {
              // Update restoreId in your database
              const fetchConfig = {
                body: { reference: data.restoreId },
                path: `${config.api.paths.customers.basepath}${config.api.paths.customers.paths.chatReference}`,
              };
              await FetchHelper.patch(fetchConfig);
            }
          }
        });
      },
    },
  };
</script>
